<div>
  <div class="urlDiv" fxLayout="row wrap">
    <a class="urls" href="userProfiles/home/{{userId}}">
      Home /
    </a>

    <a  class="urls" href="contest/all-contest">
       &nbsp;contests /
    </a>
    <a  class="urls" href="/contest/film">
        &nbsp;Film
     </a>
    </div>
  <div class="film-contest" fxLayout="column wrap">
    <img class="image" src="assets/images/contest/FilmContests.png" />
  </div>

  <div class="content-data" fxLayout="row wrap">
    <label class="heading">Enter in the world of films!</label>

    <div class="card-container">
        <div class="custom-card" *ngFor="let item of images">
          <div class="custom-card-header">
            <img class="img"   [ngStyle]="{ 'cursor':(!item.isActive)?'not-allowed':'pointer'}"
            src="{{ item.imageUrl }}" (click)="getContest(item.id)">
            <span style="cursor: pointer;" (click)="getContest(item.id)">{{item.name}}</span>
          </div>
        </div>
      </div>

      <div class="challenge-container">
        <h2>Contest + Challenge Winners</h2>
        <div>
        <owl-carousel-o [options]="carouselOptions" class="carousel">
            <ng-container *ngFor="let slide of challengeImages">
            <ng-template carouselSlide>
                <a href="/">
                    <img [src]="slide" [alt]="" [title]="">
                </a>
            </ng-template>
        </ng-container>
          </owl-carousel-o>
        </div>
      </div>

      <div class="result-container">
        <h2>Contest + Challenge Results & Archive</h2>
        <div>
        <owl-carousel-o [options]="carouselOptions">
            <ng-container *ngFor="let slide of challengeImages">
            <ng-template carouselSlide>
                <a href="/">
                    <img [src]="" [alt]="" [title]="">
                </a>
            </ng-template>
        </ng-container>
          </owl-carousel-o>
        </div>
      </div>
  </div>
</div>
